import React, { useState } from 'react';
import { submitAgentInterest } from '../utils/api';
import { toast } from 'sonner';
import { CheckCircle, Loader2 } from 'lucide-react';

export const AgentInterestForm = () => {
  const [data, setData] = useState({ firstName: '', lastName: '', email: '', phone: '' });
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const res = await submitAgentInterest(data);
      if (res.success) {
        setSubmitted(true);
        toast.success('Thanks! David Ashley will reach out within 24-48 hours.');
      }
    } catch (err) {
      toast.error('Something went wrong. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  const inputCls = 'w-full px-4 py-3 rounded-md border border-gray-300 text-gray-900 focus:outline-none focus:ring-2 focus:ring-brand-orange';

  if (submitted) {
    return (
      <div className="bg-white rounded-xl shadow-2xl p-8 text-center" data-testid="agent-interest-success">
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <CheckCircle className="text-green-600" size={36} />
        </div>
        <h3 className="text-2xl font-bold text-brand-blue mb-2">Thank You!</h3>
        <p className="text-gray-600">
          We received your information. David Ashley will personally reach out to you within the next 24 to 48 hours to schedule a time to talk.
        </p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl shadow-2xl p-8">
      <h3 className="text-2xl font-bold text-brand-blue mb-2">Interested in Becoming an Agent?</h3>
      <p className="text-gray-600 mb-6">
        Share your details and David Ashley will reach out to schedule a time to talk about the opportunity. No pressure, no obligation.
      </p>
      <form onSubmit={handleSubmit} className="space-y-4" data-testid="agent-interest-form">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">First Name *</label>
            <input
              type="text" required value={data.firstName}
              onChange={(e) => setData({ ...data, firstName: e.target.value })}
              placeholder="First name" className={inputCls} data-testid="agent-interest-first-name"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Last Name *</label>
            <input
              type="text" required value={data.lastName}
              onChange={(e) => setData({ ...data, lastName: e.target.value })}
              placeholder="Last name" className={inputCls} data-testid="agent-interest-last-name"
            />
          </div>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Email Address *</label>
          <input
            type="email" required value={data.email}
            onChange={(e) => setData({ ...data, email: e.target.value })}
            placeholder="you@email.com" className={inputCls} data-testid="agent-interest-email"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Phone Number *</label>
          <input
            type="tel" required value={data.phone}
            onChange={(e) => setData({ ...data, phone: e.target.value })}
            placeholder="(912) 376-9006" className={inputCls} data-testid="agent-interest-phone"
          />
        </div>
        <button
          type="submit" disabled={submitting}
          className="w-full bg-brand-orange text-white px-6 py-4 rounded-md hover:bg-brand-orange-light transition font-semibold text-lg disabled:opacity-50 flex items-center justify-center gap-2"
          data-testid="agent-interest-submit-btn"
        >
          {submitting ? (<><Loader2 size={20} className="animate-spin" /> Submitting...</>) : 'Request a Call'}
        </button>
      </form>
    </div>
  );
};

export default AgentInterestForm;
